import {Controller} from "stimulus";

export default class AdminModalOpenController extends Controller<HTMLElement> {
  static values = {modal: String};

  declare modalValue: string;

  open(e) {
    e.preventDefault(); // Prevent the click event doing anything else, like navigating.

    this.dispatch("trigger-open", {
      prefix: "tlw-modal",
      bubbles: true,
      detail: {
        modal: this.modalValue,
      },
    });
  }

  preview(event: Stimulus.ActionEvent) {
    const {target, template} = event.params;

    if (this.openedInNewContext(event)) return;
    if (!target || !template) return;

    const targetElement = document.getElementById(event.params.target);
    const templateElement = document.getElementById(event.params.template) as HTMLTemplateElement || null;
    const contentElement = templateElement?.content?.firstElementChild;

    if (!targetElement || !templateElement || !contentElement) return;

    targetElement.append(
      templateElement.content.firstElementChild.cloneNode(true)
    );
  }

  private openedInNewContext(event: any) {
    if (event.currentTarget.getAttribute("target") === "_blank") return true;

    return event.ctrlKey || event.metaKey || event.shiftKey || (event.button && event.button == 1);
  }
}
